import * as renderizador from '@theme/section-renderer';
import * as morfo from '@theme/morph';

(function () {
  if (window.__veeryFiltros) return;
  window.__veeryFiltros = true;

  var morphSection = renderizador.morphSection;
  var morph = morfo.morph;
  var MORPH_OPTIONS = morfo.MORPH_OPTIONS;

  var ENLACES = [
    '.vfb__muestra', '.vfb__chip', '.vfb__limpiar', '.vfb__srt', '.vfm__srt',
    '.vmc__page', '.vmc__orden', '.vmc__mas-antes', '.vmc__empty-enlace--filtro', '.vmc__empty-limpiar'
  ].join(',');
  var MAS = '[data-vmc-mas-boton]';
  var PRECARGABLES = ENLACES + ',' + MAS;
  var CADUCIDAD = 30000;
  var MAX_GUARDADAS = 12;
  var ESPERA_PRECARGA = 80;
  var ESPERA_ORDEN = 180;
  var HUECO = '987654';
  var CLAVE_MAS = 'veery-coleccion-mas';

  var conRaton = window.matchMedia('(hover: hover) and (pointer: fine)');
  var anchoEscritorio = window.matchMedia('(min-width: 750px)');
  var guardadas = new Map();
  var enCurso = null;
  var masEnCurso = null;
  var ordenPendiente = null;
  var temporizadorPrecarga = null;
  var arrastre = null;
  var turnoCuenta = 0;
  var topePendiente = false;

  function cerca(el, selector) {
    return el && el.closest ? el.closest(selector) : null;
  }

  function seccionDe(el) {
    var s = cerca(el, '[id^="shopify-section-"]');
    if (!s || !s.querySelector('.vmc__grid, [data-vfb-root], [data-vfm-drawer]')) return null;
    return s;
  }

  function direccion() {
    return window.location.pathname + window.location.search;
  }

  function claveMas() {
    return CLAVE_MAS + ':' + direccion();
  }

  function leerMas() {
    try { return JSON.parse(window.sessionStorage.getItem(claveMas()) || 'null'); } catch (e) { return null; }
  }

  function escribirMas(datos) {
    try {
      if (datos) window.sessionStorage.setItem(claveMas(), JSON.stringify(datos));
      else window.sessionStorage.removeItem(claveMas());
    } catch (e) {}
  }

  function contarObras(seccion) {
    return seccion.querySelectorAll('.vmc__grid > [data-vmc-id]').length;
  }

  function claveDe(url, seccion) {
    var u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', seccion.id.replace(/^shopify-section-/, ''));
    return u.toString();
  }

  function descargar(clave, senal) {
    return fetch(clave, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', signal: senal })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      }, function (e) {
        if (e && e.name !== 'AbortError') e.veeryRed = true;
        throw e;
      });
  }

  function sinRed(e) {
    return !!(e && e.veeryRed) || navigator.onLine === false;
  }

  function guardar(clave, promesa) {
    var g0 = { t: Date.now(), promesa: promesa };
    guardadas.set(clave, g0);
    promesa.then(function () { g0.lista = true; }, function () {});
    promesa.catch(function () {
      var g = guardadas.get(clave);
      if (g && g.promesa === promesa) guardadas.delete(clave);
    });
    while (guardadas.size > MAX_GUARDADAS) guardadas.delete(guardadas.keys().next().value);
  }

  function guardada(clave) {
    var g = guardadas.get(clave);
    if (!g) return null;
    if (Date.now() - g.t > CADUCIDAD) {
      guardadas.delete(clave);
      return null;
    }
    return g.promesa;
  }

  function enMemoria(clave) {
    var g = guardadas.get(clave);
    return !!(g && g.lista && Date.now() - g.t <= CADUCIDAD);
  }

  function trasPintar() {
    return new Promise(function (listo) {
      if (document.visibilityState === 'hidden') { listo(); return; }
      window.requestAnimationFrame(function () {
        var canal = new MessageChannel();
        canal.port1.onmessage = function () { listo(); };
        canal.port2.postMessage(0);
      });
    });
  }

  function pedir(clave, senal) {
    var promesa = guardada(clave);
    if (!promesa) {
      promesa = descargar(clave, senal);
      guardar(clave, promesa);
      if (senal) {
        senal.addEventListener('abort', function () {
          var g = guardadas.get(clave);
          if (g && g.promesa === promesa) guardadas.delete(clave);
        }, { once: true });
      }
    }
    return promesa;
  }

  function precargar(enlace) {
    var seccion = seccionDe(enlace);
    var href = enlace.getAttribute('href');
    if (!seccion || !href || href.charAt(0) === '#') return;
    var clave = claveDe(href, seccion);
    if (!guardada(clave)) guardar(clave, descargar(clave));
  }

  function pintarCargando(seccion, activo) {
    var caja = seccion.querySelector('.vmc__inner') || seccion;
    caja.classList.toggle('vmc--cargando', !!activo);
    caja.setAttribute('aria-busy', activo ? 'true' : 'false');
  }

  function soltarMedias(raiz) {
    var fuentes = raiz.querySelectorAll('source[media]');
    for (var i = 0; i < fuentes.length; i++) fuentes[i].removeAttribute('media');
  }

  function reconstruir(seccion, html) {
    var temp = document.createElement('div');
    temp.innerHTML = html.trim();
    var nueva = temp.querySelector('[id^="shopify-section-"]') || temp;
    seccion.innerHTML = nueva.innerHTML;
    soltarMedias(temp);
  }

  function sustituir(seccion, html) {
    if (typeof morph === 'function') {
      try {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nuevaSeccion = doc.getElementById(seccion.id);
        if (nuevaSeccion) {
          morph(seccion, nuevaSeccion, MORPH_OPTIONS);
          soltarMedias(doc);
          return Promise.resolve();
        }
      } catch (e) {}
    }
    if (typeof morphSection === 'function') {
      try {
        var hecho = morphSection(seccion.id.replace(/^shopify-section-/, ''), html);
        if (hecho && typeof hecho.then === 'function') {
          return hecho.catch(function () { reconstruir(seccion, html); });
        }
        return Promise.resolve();
      } catch (e) {}
    }
    reconstruir(seccion, html);
    return Promise.resolve();
  }

  function cuentaActual(seccion) {
    var raiz = seccion ? seccion.querySelector('[data-vfb-cuenta]') : null;
    var n = raiz ? parseInt(raiz.getAttribute('data-vfb-cuenta'), 10) : NaN;
    return isNaN(n) ? null : n;
  }

  function cuentaDe(html) {
    var m = /data-vfb-cuenta="(\d+)"/.exec(html);
    return m ? parseInt(m[1], 10) : null;
  }

  function pulsar(boton) {
    if (!boton || !boton.hasAttribute('data-vfm-pulso')) return;
    boton.setAttribute('data-pulse', 'true');
    setTimeout(function () { boton.removeAttribute('data-pulse'); }, 450);
  }

  function pintarBoton(boton, n) {
    if (!boton || n === null) return;
    var texto;
    if (n === 0) texto = boton.getAttribute('data-vfb-t-cero');
    else if (n === 1) texto = boton.getAttribute('data-vfb-t-uno');
    else texto = (boton.getAttribute('data-vfb-t-varios') || '').replace(HUECO, String(n));
    boton.disabled = n === 0;
    if (texto && boton.textContent !== texto) {
      boton.textContent = texto;
      pulsar(boton);
    }
  }

  function opcionesDe(ambito) {
    return ambito.querySelectorAll('[data-vfb-opcion]');
  }

  function borradorIgual(ambito) {
    var ops = opcionesDe(ambito);
    for (var i = 0; i < ops.length; i++) {
      if (ops[i].getAttribute('aria-pressed') !== ops[i].getAttribute('data-vfb-activo')) return false;
    }
    return true;
  }

  function urlBorrador(ambito) {
    var u = new URL(window.location.href);
    u.searchParams.delete('page');
    u.searchParams.delete('section_id');
    var ops = opcionesDe(ambito);
    var porParam = {};
    var orden = [];
    for (var i = 0; i < ops.length; i++) {
      var p = ops[i].getAttribute('data-vfb-param');
      if (!p) continue;
      if (!porParam[p]) {
        porParam[p] = [];
        orden.push(p);
      }
      if (ops[i].getAttribute('aria-pressed') === 'true') porParam[p].push(ops[i].getAttribute('data-vfb-valor'));
    }
    for (var j = 0; j < orden.length; j++) {
      u.searchParams.delete(orden[j]);
      for (var k = 0; k < porParam[orden[j]].length; k++) u.searchParams.append(orden[j], porParam[orden[j]][k]);
    }
    return u.pathname + u.search;
  }

  function botonDe(ambito) {
    return ambito.querySelector('[data-vfb-aplicar], [data-vfm-aplicar]');
  }

  function resumirCajon(cajon) {
    var total = 0;
    var grupos = cajon.querySelectorAll('[data-vfm-group]');
    for (var i = 0; i < grupos.length; i++) {
      var marcadas = grupos[i].querySelectorAll('[data-vfb-opcion][aria-pressed="true"]');
      var nombres = [];
      for (var j = 0; j < marcadas.length; j++) nombres.push(marcadas[j].getAttribute('data-vfb-nombre'));
      total += marcadas.length;
      var elegido = grupos[i].querySelector('[data-vfm-elegido]');
      if (elegido) elegido.textContent = nombres.join(', ');
      var n = grupos[i].querySelector('[data-vfm-n]');
      if (n) {
        n.textContent = String(marcadas.length);
        n.hidden = marcadas.length === 0;
      }
    }
    var sub = cajon.querySelector('[data-vfm-sub]');
    if (sub) {
      var texto = total === 1 ? sub.getAttribute('data-vfm-sub-uno') : (sub.getAttribute('data-vfm-sub-varios') || '').replace(HUECO, String(total));
      if (texto) sub.textContent = texto;
      sub.hidden = total === 0;
    }
  }

  function actualizarCuenta(ambito) {
    var seccion = seccionDe(ambito);
    var boton = botonDe(ambito);
    if (!seccion || !boton) return;
    var mio = ++turnoCuenta;
    if (borradorIgual(ambito)) {
      boton.removeAttribute('aria-busy');
      pintarBoton(boton, cuentaActual(seccion));
      return;
    }
    boton.setAttribute('aria-busy', 'true');
    pedir(claveDe(urlBorrador(ambito), seccion))
      .then(function (html) {
        if (mio !== turnoCuenta) return;
        pintarBoton(boton, cuentaDe(html));
      })
      .catch(function () {})
      .finally(function () {
        if (mio === turnoCuenta) boton.removeAttribute('aria-busy');
      });
  }

  function deshacer(ambito) {
    var ops = opcionesDe(ambito);
    var cambio = false;
    for (var i = 0; i < ops.length; i++) {
      var activo = ops[i].getAttribute('data-vfb-activo');
      if (ops[i].getAttribute('aria-pressed') !== activo) {
        ops[i].setAttribute('aria-pressed', activo);
        cambio = true;
      }
    }
    if (!cambio) return;
    turnoCuenta++;
    if (ambito.hasAttribute('data-vfm-drawer')) resumirCajon(ambito);
    var boton = botonDe(ambito);
    if (boton) {
      boton.removeAttribute('aria-busy');
      pintarBoton(boton, cuentaActual(seccionDe(ambito)));
    }
  }

  function desmarcar(ambito) {
    var ops = opcionesDe(ambito);
    for (var i = 0; i < ops.length; i++) ops[i].setAttribute('aria-pressed', 'false');
  }

  function ponerItem(item, abierto, sinDeshacer) {
    item.setAttribute('data-open', abierto ? 'true' : 'false');
    var t = item.querySelector('[data-vfb-trigger]');
    if (t) t.setAttribute('aria-expanded', abierto ? 'true' : 'false');
    if (!abierto && !sinDeshacer) deshacer(item);
  }

  function cerrarItems(raiz) {
    var abiertos = raiz.querySelectorAll('[data-vfb-item][data-open="true"]');
    for (var i = 0; i < abiertos.length; i++) ponerItem(abiertos[i], false);
    return abiertos.length ? abiertos[0] : null;
  }

  function cerrarTodosLosItems() {
    var raices = document.querySelectorAll('[data-vfb-root]');
    var ultimo = null;
    for (var i = 0; i < raices.length; i++) ultimo = cerrarItems(raices[i]) || ultimo;
    return ultimo;
  }

  var CAPA_ARRIBA = !!(window.CSS && CSS.supports && CSS.supports('selector(:popover-open)'));
  var sinMovimiento = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function subirACapa(el) {
    if (!CAPA_ARRIBA || !el || !el.hasAttribute('popover')) return;
    try { if (!el.matches(':popover-open')) el.showPopover(); } catch (e) {}
  }

  function bajarDeCapa(el) {
    if (!CAPA_ARRIBA || !el || el.getAttribute('data-open') === 'true') return;
    try { if (el.matches(':popover-open')) el.hidePopover(); } catch (e) {}
  }

  function cerrarCajones(seccion, sinDeshacer, alInstante) {
    var cs = seccion.querySelectorAll('[data-vfm-drawer]');
    var habiaAbierto = null;
    for (var i = 0; i < cs.length; i++) {
      if (cs[i].getAttribute('data-open') === 'true') {
        habiaAbierto = cs[i].getAttribute('data-vfm-drawer');
        if (!sinDeshacer) deshacer(cs[i]);
      }
      cs[i].setAttribute('data-open', 'false');
      cs[i].setAttribute('aria-hidden', 'true');
      cs[i].removeAttribute('data-dragging');
      cs[i].style.transform = '';
    }
    var v = seccion.querySelector('[data-vfm-overlay]');
    if (v) v.setAttribute('data-open', 'false');
    if (alInstante || (sinMovimiento && sinMovimiento.matches)) {
      for (var j = 0; j < cs.length; j++) bajarDeCapa(cs[j]);
      bajarDeCapa(v);
    }
    document.body.style.overflow = '';
    return habiaAbierto;
  }

  function abrirCajon(seccion, nombre, conPulso) {
    var cs = seccion.querySelectorAll('[data-vfm-drawer]');
    var cabecera = document.querySelector('.header-veery');
    var tope = !CAPA_ARRIBA && cabecera ? Math.max(0, Math.round(cabecera.getBoundingClientRect().bottom)) : 0;
    var abierto = null;
    for (var i = 0; i < cs.length; i++) {
      var es = cs[i].getAttribute('data-vfm-drawer') === nombre;
      cs[i].setAttribute('data-open', es ? 'true' : 'false');
      cs[i].setAttribute('aria-hidden', es ? 'false' : 'true');
      cs[i].removeAttribute('data-dragging');
      cs[i].style.transform = '';
      cs[i].style.setProperty('--vfm-tope', tope + 'px');
      if (es) abierto = cs[i];
    }
    var v = seccion.querySelector('[data-vfm-overlay]');
    subirACapa(v);
    subirACapa(abierto);
    if (v) v.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
    if (conPulso && nombre === 'filters') pulsar(seccion.querySelector('.vfm__apply[data-vfm-pulso]'));
    return abierto;
  }

  function marcarGrupo(grupo, abierto) {
    grupo.setAttribute('data-open', abierto ? 'true' : 'false');
    var b = grupo.querySelector('[data-vfm-group-toggle]');
    if (b) b.setAttribute('aria-expanded', abierto ? 'true' : 'false');
  }

  function ponerGrupo(grupo, abierto) {
    if (abierto) {
      var cajon = cerca(grupo, '[data-vfm-drawer]');
      var otros = cajon ? cajon.querySelectorAll('[data-vfm-group][data-open="true"]') : [];
      for (var i = 0; i < otros.length; i++) {
        if (otros[i] !== grupo) marcarGrupo(otros[i], false);
      }
    }
    marcarGrupo(grupo, abierto);
  }

  function estadoMovil(seccion) {
    var abierto = seccion.querySelector('[data-vfm-drawer][data-open="true"]');
    if (!abierto) return null;
    var cuerpo = abierto.querySelector('.vfm__body');
    var grupos = [];
    var todos = abierto.querySelectorAll('[data-vfm-group]');
    for (var i = 0; i < todos.length; i++) {
      if (todos[i].getAttribute('data-open') === 'true') grupos.push(i);
    }
    return { nombre: abierto.getAttribute('data-vfm-drawer'), scroll: cuerpo ? cuerpo.scrollTop : 0, grupos: grupos };
  }

  function restaurarMovil(seccion, estado) {
    if (!estado) {
      document.body.style.overflow = '';
      return;
    }
    abrirCajon(seccion, estado.nombre, false);
    var abierto = seccion.querySelector('[data-vfm-drawer="' + estado.nombre + '"]');
    if (!abierto) return;
    var todos = abierto.querySelectorAll('[data-vfm-group]');
    for (var i = 0; i < estado.grupos.length; i++) {
      var g = todos[estado.grupos[i]];
      if (g) ponerGrupo(g, true);
    }
    var cuerpo = abierto.querySelector('.vfm__body');
    if (cuerpo) cuerpo.scrollTop = estado.scroll;
  }

  function focoActual(seccion) {
    var a = document.activeElement;
    if (!a || a === document.body || !seccion.contains(a)) return null;
    var item = cerca(a, '[data-vfb-item]');
    var disparadores = seccion.querySelectorAll('[data-vfb-trigger]');
    var indice = -1;
    if (item) {
      var t = item.querySelector('[data-vfb-trigger]');
      for (var i = 0; i < disparadores.length; i++) if (disparadores[i] === t) indice = i;
    }
    return { clave: a.getAttribute('data-vf-clave'), disparador: indice };
  }

  function visible(el) {
    if (!el || !el.getClientRects().length) return false;
    return getComputedStyle(el).visibility !== 'hidden';
  }

  function enfocar(el) {
    if (!el) return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }

  function restaurarFoco(seccion, foco) {
    if (!foco) return;
    var destino = null;
    if (foco.clave) {
      var candidatos = seccion.querySelectorAll('[data-vf-clave]');
      for (var i = 0; i < candidatos.length && !destino; i++) {
        if (candidatos[i].getAttribute('data-vf-clave') === foco.clave && visible(candidatos[i])) destino = candidatos[i];
      }
    }
    if (!destino && foco.disparador >= 0) destino = seccion.querySelectorAll('[data-vfb-trigger]')[foco.disparador] || null;
    enfocar(destino);
  }

  function tapaDe(seccion) {
    var fija = seccion.querySelector('[data-vfb-pegajosa]');
    return fija ? fija.getBoundingClientRect().height + (parseFloat(getComputedStyle(fija).top) || 0) : 0;
  }

  function subirARejilla(seccion) {
    var vistas = seccion.querySelectorAll('.vmc__grid, .vmc__indice, .vmc__empty');
    for (var v = 0; v < vistas.length; v++) {
      if (!vistas[v].getClientRects().length) continue;
      var arriba = vistas[v].getBoundingClientRect().top;
      var tapa = tapaDe(seccion);
      if (arriba - tapa < 0) window.scrollTo({ top: window.scrollY + arriba - tapa - 24, behavior: 'instant' });
      return;
    }
  }

  function avisarOtrosModulos() {
    try {
      if (window.VeeryColeccionVistas) window.VeeryColeccionVistas.sincronizar();
    } catch (e) {}
    try {
      if (window.VeeryWishlist) document.dispatchEvent(new CustomEvent('veery:wishlist:change'));
    } catch (e) {}
  }

  function cancelarMas() {
    if (masEnCurso) masEnCurso.abort();
    masEnCurso = null;
  }

  function avisar(ambito, tipo) {
    var aviso = ambito ? ambito.querySelector('[data-vmc-aviso="' + tipo + '"]') : null;
    if (!aviso) return false;
    aviso.textContent = aviso.getAttribute('data-vmc-t-red') || '';
    return true;
  }

  function callar(ambito, tipo) {
    var aviso = ambito ? ambito.querySelector('[data-vmc-aviso="' + tipo + '"]') : null;
    if (aviso && aviso.textContent) aviso.textContent = '';
  }

  function ir(url, seccion, empujarHistorial, sinCajon) {
    var clave = claveDe(url, seccion);
    if (enCurso && enCurso.clave === clave) return;
    if (enCurso) enCurso.abort();
    cancelarMas();
    var control = new AbortController();
    control.clave = clave;
    enCurso = control;
    var estado = sinCajon ? null : estadoMovil(seccion);
    var foco = focoActual(seccion);
    var ceder = enMemoria(clave);
    pintarCargando(seccion, true);
    callar(seccion, 'filtros');

    pedir(clave, control.signal)
      .then(function (html) {
        if (control.signal.aborted || !ceder) return html;
        return trasPintar().then(function () { return html; });
      })
      .then(function (html) {
        if (control.signal.aborted) return;
        cancelarMas();
        return sustituir(seccion, html).then(function () {
          if (empujarHistorial) window.history.pushState({ veeryFiltro: true }, '', url);
          escribirMas(null);
          avisarOtrosModulos();
          restaurarMovil(seccion, estado);
          restaurarFoco(seccion, foco);
          ponerTope();
          subirARejilla(seccion);
          document.dispatchEvent(new CustomEvent('veery:filtros:cambio', { detail: { url: url } }));
        });
      })
      .catch(function (e) {
        if (control.signal.aborted || (e && e.name === 'AbortError')) return;
        if (sinRed(e) && avisar(seccion, 'filtros')) {
          if (!empujarHistorial) window.addEventListener('online', function () { ir(window.location.href, seccion, false); }, { once: true });
          return;
        }
        window.location.href = url;
      })
      .finally(function () {
        if (enCurso !== control) return;
        enCurso = null;
        pintarCargando(seccion, false);
      });
  }

  function aplicarBorrador(ambito, seccion) {
    var igual = borradorIgual(ambito);
    var url = urlBorrador(ambito);
    turnoCuenta++;
    if (ambito.hasAttribute('data-vfm-drawer')) {
      var nombre = cerrarCajones(seccion, true);
      enfocar(nombre ? seccion.querySelector('[data-vfm-open="' + nombre + '"]') : null);
    } else {
      ponerItem(ambito, false, true);
      enfocar(ambito.querySelector('[data-vfb-trigger]'));
    }
    if (!igual) ir(url, seccion, true, true);
  }

  function aplicarAlContar(ambito, seccion) {
    var turno = turnoCuenta;
    pedir(claveDe(urlBorrador(ambito), seccion)).then(function (html) {
      if (turno === turnoCuenta && cuentaDe(html) !== 0) aplicarBorrador(ambito, seccion);
    }, function () {
      if (turno === turnoCuenta) aplicarBorrador(ambito, seccion);
    });
  }

  function elegirOrden(enlace, seccion) {
    var href = enlace.getAttribute('href');
    if (ordenPendiente) {
      if (ordenPendiente.href === href) return;
      clearTimeout(ordenPendiente.reloj);
    }
    var grupo = cerca(enlace, '[role="radiogroup"]');
    var radios = grupo ? grupo.querySelectorAll('[role="radio"]') : [];
    for (var i = 0; i < radios.length; i++) radios[i].setAttribute('aria-checked', radios[i] === enlace ? 'true' : 'false');
    ordenPendiente = { href: href };
    ordenPendiente.reloj = setTimeout(function () {
      ordenPendiente = null;
      var nombre = cerrarCajones(seccion, true);
      enfocar(nombre ? seccion.querySelector('[data-vfm-open="' + nombre + '"]') : null);
      ir(href, seccion, true, true);
    }, ESPERA_ORDEN);
  }

  function anadirNuevas(destino, origen, selector) {
    var primera = null;
    if (!destino) return null;
    var nuevas = origen.querySelectorAll(selector);
    for (var i = 0; i < nuevas.length; i++) {
      var id = nuevas[i].getAttribute('data-vmc-id');
      if (id && destino.querySelector(':scope > [data-vmc-id="' + id + '"]')) continue;
      var copia = document.importNode(nuevas[i], true);
      copia.classList.add('vmc__nueva');
      destino.appendChild(copia);
      if (!primera) primera = copia;
    }
    return primera;
  }

  function actualizarBloqueMas(bloque, nuevo) {
    var cuenta = bloque.querySelector('.vmc__mas-cuenta');
    var cuentaNueva = nuevo ? nuevo.querySelector('.vmc__mas-cuenta') : null;
    if (cuenta && cuentaNueva) cuenta.textContent = cuentaNueva.textContent;
    var boton = bloque.querySelector(MAS);
    var botonNuevo = nuevo ? nuevo.querySelector(MAS) : null;
    if (boton && botonNuevo) boton.setAttribute('href', botonNuevo.getAttribute('href'));
    else if (boton) boton.remove();
    if (!bloque.querySelector('.vmc__mas-cuenta, ' + MAS)) bloque.remove();
  }

  function enfocarPrimera(celda, fila) {
    var destino = null;
    if (celda && celda.getClientRects().length) destino = celda.querySelector('a[href]');
    if (!destino && fila && fila.getClientRects().length) destino = fila.querySelector('a[href]');
    enfocar(destino);
  }

  function recordarMas(seccion) {
    var previo = leerMas();
    var mismo = previo && previo.u === direccion();
    escribirMas({ u: direccion(), n: contarObras(seccion), id: mismo ? previo.id : null, y: mismo ? previo.y : null });
  }

  function cargarMas(boton, seccion, alRecuperar) {
    if (masEnCurso) return Promise.resolve(false);
    var href = boton.getAttribute('href');
    var bloque = cerca(boton, '[data-vmc-mas]');
    var rejilla = seccion.querySelector('.vmc__grid');
    if (!href || !bloque || !rejilla) return Promise.resolve(false);
    var control = new AbortController();
    masEnCurso = control;
    boton.setAttribute('aria-disabled', 'true');
    rejilla.setAttribute('aria-busy', 'true');
    callar(bloque, 'mas');

    return pedir(claveDe(href, seccion), control.signal)
      .then(function (html) {
        if (control.signal.aborted) return false;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var celda = anadirNuevas(rejilla, doc, '.vmc__grid > [data-vmc-id]');
        var fila = anadirNuevas(seccion.querySelector('.vmc__tabla tbody'), doc, '.vmc__tabla tbody > [data-vmc-id]');
        actualizarBloqueMas(bloque, doc.querySelector('[data-vmc-mas]'));
        soltarMedias(doc);
        avisarOtrosModulos();
        recordarMas(seccion);
        if (!alRecuperar) enfocarPrimera(celda, fila);
        document.dispatchEvent(new CustomEvent('veery:coleccion:mas', { detail: { url: href } }));
        return true;
      })
      .catch(function (e) {
        if (control.signal.aborted || alRecuperar) return false;
        if (sinRed(e) && avisar(bloque, 'mas')) return false;
        window.location.href = href;
        return false;
      })
      .finally(function () {
        if (masEnCurso !== control) return;
        masEnCurso = null;
        boton.removeAttribute('aria-disabled');
        rejilla.setAttribute('aria-busy', 'false');
      });
  }

  function ponerTope() {
    topePendiente = false;
    var fijas = document.querySelectorAll('[data-vfb-pegajosa]');
    if (!fijas.length) return;
    var cabecera = document.querySelector('.header-veery');
    var seccionCabecera = cabecera ? cabecera.closest('.shopify-section') : null;
    var tope = 0;
    if (seccionCabecera && getComputedStyle(seccionCabecera).position === 'sticky') {
      var compacto = cabecera.classList.contains('hv-compacto') ? parseFloat(getComputedStyle(cabecera).getPropertyValue('--hv-compacto-movil')) : NaN;
      tope = isNaN(compacto) ? Math.max(0, Math.round(cabecera.getBoundingClientRect().bottom)) : Math.round(compacto);
    }
    var valor = tope + 'px';
    for (var i = 0; i < fijas.length; i++) {
      if (fijas[i].style.getPropertyValue('--vfb-tope') !== valor) fijas[i].style.setProperty('--vfb-tope', valor);
    }
  }

  function pedirTope() {
    if (topePendiente) return;
    topePendiente = true;
    window.requestAnimationFrame(ponerTope);
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented) return;
    var t = e.target;
    var modificada = e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0;

    var obra = cerca(t, '.vmc__grid > [data-vmc-id], .vmc__tabla tbody > [data-vmc-id]');
    if (obra && cerca(t, 'a[href]')) {
      var recuerdo = leerMas();
      var seccionObra = seccionDe(obra);
      if ((!recuerdo || recuerdo.u !== direccion()) && seccionObra) recuerdo = { u: direccion(), n: contarObras(seccionObra), id: null, y: null };
      if (recuerdo) {
        recuerdo.id = obra.getAttribute('data-vmc-id');
        escribirMas(recuerdo);
      }
    }

    var mas = cerca(t, MAS);
    if (mas && !modificada) {
      var seccionMas = seccionDe(mas);
      if (seccionMas) {
        e.preventDefault();
        cargarMas(mas, seccionMas);
        return;
      }
    }

    var enlace = cerca(t, ENLACES);
    if (enlace && enlace.tagName === 'A' && !modificada) {
      var href = enlace.getAttribute('href');
      var seccionEnlace = seccionDe(enlace);
      if (href && href.charAt(0) !== '#' && seccionEnlace) {
        e.preventDefault();
        if (enlace.classList.contains('vfm__srt')) {
          elegirOrden(enlace, seccionEnlace);
          return;
        }
        ir(href, seccionEnlace, true);
        return;
      }
    }

    var opcion = cerca(t, '[data-vfb-opcion]');
    if (opcion) {
      if (opcion.disabled) return;
      opcion.setAttribute('aria-pressed', opcion.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      var ambito = cerca(opcion, '[data-vfb-item], [data-vfm-drawer]');
      if (ambito) {
        if (ambito.hasAttribute('data-vfm-drawer')) resumirCajon(ambito);
        actualizarCuenta(ambito);
      }
      return;
    }

    var reinicio = cerca(t, '[data-vfb-reset]');
    if (reinicio) {
      var itemReinicio = cerca(reinicio, '[data-vfb-item]');
      if (itemReinicio) {
        desmarcar(itemReinicio);
        actualizarCuenta(itemReinicio);
      }
      return;
    }

    var aplicar = cerca(t, '[data-vfb-aplicar], [data-vfm-aplicar]');
    if (aplicar) {
      var ambitoAplicar = cerca(aplicar, '[data-vfb-item], [data-vfm-drawer]');
      var seccionAplicar = seccionDe(aplicar);
      if (ambitoAplicar && seccionAplicar && !aplicar.disabled) {
        if (aplicar.getAttribute('aria-busy') === 'true') aplicarAlContar(ambitoAplicar, seccionAplicar);
        else aplicarBorrador(ambitoAplicar, seccionAplicar);
      }
      return;
    }

    var limpiar = cerca(t, '[data-vfm-limpiar]');
    if (limpiar) {
      var cajonLimpiar = cerca(limpiar, '[data-vfm-drawer]');
      if (cajonLimpiar) {
        desmarcar(cajonLimpiar);
        resumirCajon(cajonLimpiar);
        actualizarCuenta(cajonLimpiar);
      }
      return;
    }

    var disparador = cerca(t, '[data-vfb-trigger]');
    if (disparador) {
      var item = cerca(disparador, '[data-vfb-item]');
      var raiz = cerca(disparador, '[data-vfb-root]');
      if (item && raiz) {
        var estabaAbierto = item.getAttribute('data-open') === 'true';
        cerrarItems(raiz);
        if (!estabaAbierto) ponerItem(item, true);
      }
      return;
    }

    var abrir = cerca(t, '[data-vfm-open]');
    if (abrir) {
      var sa = seccionDe(abrir);
      if (sa) {
        var cajonAbierto = abrirCajon(sa, abrir.getAttribute('data-vfm-open'), true);
        enfocar(cajonAbierto);
      }
      return;
    }

    var cierre = cerca(t, '[data-vfm-close], [data-vfm-overlay]');
    if (cierre) {
      var sc = seccionDe(cierre);
      if (sc) {
        var cerrado = cerrarCajones(sc);
        enfocar(cerrado ? sc.querySelector('[data-vfm-open="' + cerrado + '"]') : null);
      }
      return;
    }

    var cabeza = cerca(t, '[data-vfm-group-toggle]');
    if (cabeza) {
      var grupo = cerca(cabeza, '[data-vfm-group]');
      if (grupo) ponerGrupo(grupo, grupo.getAttribute('data-open') !== 'true');
      return;
    }

    var raices = document.querySelectorAll('[data-vfb-root]');
    for (var r = 0; r < raices.length; r++) {
      if (!raices[r].contains(t)) cerrarItems(raices[r]);
    }
  }, true);

  function atraparTab(e) {
    var cajon = document.querySelector('[data-vfm-drawer][data-open="true"]');
    if (!cajon || !visible(cajon)) return;
    var lista = Array.prototype.filter.call(cajon.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'), visible);
    if (!lista.length) {
      e.preventDefault();
      return;
    }
    var activo = document.activeElement;
    var i = lista.indexOf(activo);
    var dentro = cajon.contains(activo);
    if (e.shiftKey && (!dentro || i <= 0)) {
      e.preventDefault();
      enfocar(lista[lista.length - 1]);
    } else if (!e.shiftKey && (!dentro || i === lista.length - 1)) {
      e.preventDefault();
      enfocar(lista[0]);
    }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') {
      atraparTab(e);
      return;
    }
    if (e.key === 'Escape') {
      var item = cerrarTodosLosItems();
      if (item) {
        enfocar(item.querySelector('[data-vfb-trigger]'));
        return;
      }
      var abierto = document.querySelector('[data-vfm-drawer][data-open="true"]');
      var sm = abierto ? seccionDe(abierto) : null;
      if (sm) {
        var nombre = cerrarCajones(sm);
        enfocar(nombre ? sm.querySelector('[data-vfm-open="' + nombre + '"]') : null);
      }
      return;
    }
    if ((e.key === ' ' || e.key === 'Spacebar') && e.target && e.target.matches && e.target.matches('a[role="checkbox"], a[role="button"], a[role="radio"]')) {
      e.preventDefault();
      e.target.click();
    }
  });

  document.addEventListener('pointerover', function (e) {
    if (!conRaton.matches) return;
    var enlace = cerca(e.target, PRECARGABLES);
    if (!enlace || enlace.tagName !== 'A') return;
    clearTimeout(temporizadorPrecarga);
    temporizadorPrecarga = setTimeout(function () { precargar(enlace); }, ESPERA_PRECARGA);
  }, { passive: true });

  document.addEventListener('pointerout', function (e) {
    if (cerca(e.target, PRECARGABLES)) clearTimeout(temporizadorPrecarga);
  }, { passive: true });

  function inicioArrastre(e) {
    var asa = cerca(e.target, '[data-vfm-handle]');
    var cajon = asa ? cerca(asa, '[data-vfm-drawer]') : null;
    if (!cajon || cajon.getAttribute('data-vfm-arrastre') !== 'true') return;
    var p = e.touches ? e.touches[0] : e;
    if (!p) return;
    arrastre = { cajon: cajon, inicio: p.clientY, actual: p.clientY, alto: cajon.offsetHeight };
    cajon.setAttribute('data-dragging', 'true');
  }

  function moverArrastre(e) {
    if (!arrastre) return;
    var p = e.touches ? e.touches[0] : e;
    if (!p) return;
    arrastre.actual = p.clientY;
    arrastre.cajon.style.transform = 'translateY(' + Math.max(0, arrastre.actual - arrastre.inicio) + 'px)';
  }

  function finArrastre() {
    if (!arrastre) return;
    var a = arrastre;
    arrastre = null;
    a.cajon.removeAttribute('data-dragging');
    a.cajon.style.transform = '';
    if (a.actual - a.inicio > a.alto * 0.28) {
      var s = seccionDe(a.cajon);
      if (s) cerrarCajones(s);
    }
  }

  document.addEventListener('touchstart', inicioArrastre, { passive: true });
  document.addEventListener('touchmove', moverArrastre, { passive: true });
  document.addEventListener('touchend', finArrastre);
  document.addEventListener('touchcancel', finArrastre);
  document.addEventListener('mousedown', inicioArrastre);
  document.addEventListener('mousemove', moverArrastre);
  document.addEventListener('mouseup', finArrastre);

  document.addEventListener('transitionend', function (e) {
    if (e.propertyName !== 'visibility' || !e.target.matches) return;
    if (e.target.matches('[data-vfm-drawer], [data-vfm-overlay]')) bajarDeCapa(e.target);
  });

  window.addEventListener('scroll', pedirTope, { passive: true });
  window.addEventListener('resize', pedirTope, { passive: true });

  window.addEventListener('pagehide', function () {
    var interior = document.querySelector('[id^="shopify-section-"] .vmc__inner');
    var seccion = interior ? seccionDe(interior) : null;
    if (!seccion) return;
    var previo = leerMas();
    var mismo = previo && previo.u === direccion();
    escribirMas({ u: direccion(), n: contarObras(seccion), id: mismo ? previo.id : null, y: window.scrollY });
  });

  window.addEventListener('popstate', function () {
    var interior = document.querySelector('[id^="shopify-section-"] .vmc__inner');
    var seccion = interior ? seccionDe(interior) : null;
    if (seccion) ir(window.location.href, seccion, false);
  });

  function alPasarAEscritorio(e) {
    if (!e.matches) return;
    var abiertos = document.querySelectorAll('[data-vfm-drawer][data-open="true"]');
    for (var i = 0; i < abiertos.length; i++) {
      var s = seccionDe(abiertos[i]);
      if (s) cerrarCajones(s, false, true);
    }
  }

  if (anchoEscritorio.addEventListener) anchoEscritorio.addEventListener('change', alPasarAEscritorio);
  else if (anchoEscritorio.addListener) anchoEscritorio.addListener(alPasarAEscritorio);

  var VIEJOS = {
    'filter.p.m.custom.colors': 'filter.p.m.veery.color',
    'filter.p.m.custom.style': 'filter.p.m.veery.style',
    'filter.p.m.custom.theme': 'filter.p.m.veery.theme',
    'filter.p.m.custom.room': 'filter.p.m.veery.room',
    'filter.p.m.custom.orientation': 'filter.p.m.veery.format'
  };

  function aHandle(texto) {
    return String(texto).toLowerCase().replace(/&/g, ' ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function convertirUrlVieja() {
    var parametros = new URLSearchParams(window.location.search);
    var nuevos = new URLSearchParams();
    var cambio = false;
    parametros.forEach(function (valor, nombre) {
      var destino = VIEJOS[nombre];
      if (!destino || !document.querySelector('[data-vf-clave^="' + destino + ':"]')) {
        nuevos.append(nombre, valor);
        return;
      }
      cambio = true;
      var opcion = document.querySelector('[data-vf-clave^="' + destino + ':"][data-vf-h="' + aHandle(valor) + '"]');
      if (opcion) nuevos.append(destino, opcion.getAttribute('data-vf-clave').slice(destino.length + 1));
    });
    if (!cambio) return false;
    var consulta = nuevos.toString();
    window.location.replace(window.location.pathname + (consulta ? '?' + consulta : '') + window.location.hash);
    return true;
  }

  function destapar() {
    var raiz = document.documentElement;
    if (!raiz.classList.contains('vmc-volviendo')) return;
    raiz.classList.add('vmc-fundido');
    raiz.classList.remove('vmc-volviendo', 'vmc-esperando');
  }

  function esperarFotos(seccion) {
    var raiz = document.documentElement;
    if (!window.Promise || !raiz.classList.contains('vmc-volviendo')) return null;
    var alto = window.innerHeight || document.documentElement.clientHeight;
    var esperas = [];
    var imgs = seccion.querySelectorAll('.vmc__grid img, .vmc__indice img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var caja = img.getBoundingClientRect();
      if (!caja.width || caja.bottom <= 0 || caja.top >= alto) continue;
      if (img.complete && img.naturalWidth) continue;
      img.loading = 'eager';
      img.setAttribute('fetchpriority', 'high');
      esperas.push(img.decode ? img.decode().catch(function () {}) : Promise.resolve());
    }
    if (!esperas.length) return null;
    raiz.classList.add('vmc-esperando');
    var tope = null;
    var animaciones = raiz.getAnimations ? raiz.getAnimations() : [];
    for (var a = 0; a < animaciones.length; a++) if (animaciones[a].animationName === 'vmc-espera-fotos') tope = animaciones[a].finished;
    return tope ? Promise.race([Promise.all(esperas), tope]) : Promise.all(esperas);
  }

  function recuperarMas() {
    var recuerdo = leerMas();
    if (!recuerdo || recuerdo.u !== direccion()) { destapar(); return; }
    var nav = window.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    if (!nav || nav.type !== 'back_forward') {
      escribirMas(null);
      destapar();
      return;
    }
    var interior = document.querySelector('[id^="shopify-section-"] .vmc__inner');
    var seccion = interior ? seccionDe(interior) : null;
    if (!seccion) { destapar(); return; }
    var tocado = false;
    var gestos = ['wheel', 'touchstart', 'keydown', 'pointerdown'];
    function marcar() { tocado = true; destapar(); }
    for (var i = 0; i < gestos.length; i++) window.addEventListener(gestos[i], marcar, { once: true, passive: true, capture: true });

    function colocar() {
      for (var j = 0; j < gestos.length; j++) window.removeEventListener(gestos[j], marcar, { capture: true });
      if (tocado) { destapar(); return; }
      if (typeof recuerdo.y === 'number') {
        window.scrollTo({ top: recuerdo.y, behavior: 'instant' });
      } else {
        var destino = null;
        var id = String(recuerdo.id || '').replace(/\D/g, '');
        if (id) {
          var candidatas = seccion.querySelectorAll('[data-vmc-id="' + id + '"]');
          for (var k = 0; k < candidatas.length && !destino; k++) if (candidatas[k].getClientRects().length) destino = candidatas[k];
        }
        if (destino) window.scrollTo({ top: window.scrollY + destino.getBoundingClientRect().top - tapaDe(seccion) - 24, behavior: 'instant' });
      }
      var fotos = esperarFotos(seccion);
      if (fotos) fotos.then(destapar, destapar);
      else destapar();
    }

    (function siguiente() {
      var boton = seccion.querySelector(MAS);
      if (!boton || contarObras(seccion) >= recuerdo.n) { colocar(); return; }
      cargarMas(boton, seccion, true).then(function (bien) { if (bien) siguiente(); else colocar(); });
    })();
  }

  ponerTope();
  if (!convertirUrlVieja()) {
    try { recuperarMas(); } catch (e) { destapar(); }
  }
})();
